<template>
  <div class="edit-package">
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-row>
            <v-col cols="12">
              <v-btn :to="{ name: 'profile' }" large text
                ><v-icon left>mdi-chevron-left</v-icon> Profile</v-btn
              >
            </v-col>

            <v-col cols="12" class="d-flex justify-center">
              <v-card max-width="700" width="700" class="pa-5">
                <div class="text-secondary lg mb-4">
                  Current available Tokens: {{ userData.unused_tokens }}
                </div>

                <v-checkbox
                  v-model="purchase_tokens"
                  label="I would like to purchase more Tokens"
                  dense
                />

                <v-expand-transition>
                  <div v-show="purchase_tokens">
                    <!-- Numeric input to select number of tokens desired to purchase, must be more than one -->
                    <v-text-field
                      type="number"
                      v-model="tokens"
                      :min="1"
                      label="Number of Tokens to purchase"
                      class="mt-5"
                      append-outer-icon="mdi-plus"
                      @click:append-outer="increment"
                      prepend-icon="mdi-minus"
                      @click:prepend="decrement"
                    />

                    <h3 class="text-secondary lg">Order Summary</h3>
                    <div class="d-flex justify-space-between my-3">
                      <div>Price Per Token</div>
                      <div>${{ pricePerToken.toFixed(2) }}</div>
                    </div>
                    <div class="d-flex justify-space-between my-3">
                      <div>Number of Tokens to Purchase</div>
                      <div>{{ tokens }}</div>
                    </div>
                    <div class="d-flex justify-space-between my-3">
                      <div>Total Amount</div>
                      <div>${{ total.toFixed(2) }}</div>
                    </div>

                    <div class="pt-10">
                      <h3 class="text-secondary lg">Payment Information</h3>

                      <div id="card-element" class="mt-2 pt-3" />
                      <v-alert v-if="card_errors.length" dense border="left" type="error">
                        {{ card_errors[0] }}
                      </v-alert>
                    </div>

                    <div class="text-right mt-5 pt-5">
                      <v-btn
                        color="primary"
                        large
                        block
                        :disabled="purchasing"
                        @click="purchaseTokens"
                        >Purchase Tokens</v-btn
                      >
                    </div>

                    <div class="mt-10">
                      <ul>
                        <li class="mb-2">Tokens do not expire and can accumulate.</li>
                        <li class="mb-2">
                          Once purchased, you can find your new Tokens on the Shop Flings page.
                          Please note that you may need to refresh the page to view your tokens.
                        </li>
                        <li class="mb-2">All Token sales and redemptions are FINAL.</li>
                      </ul>
                    </div>
                  </div>
                </v-expand-transition>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Stripe from "@/mixins/Stripe.vue";

export default {
  name: "EditPackageView",
  mixins: [Stripe],
  data() {
    return {
      tokens: 1,
      purchase_tokens: false,
      purchasing: false,
      card_errors: [],
    };
  },

  async created() {
    await this.refresh();
  },

  computed: {
    pricePerToken() {
      if (this.userData.package) {
        return Number(this.userData.package.single_token_cost);
      } else {
        return 20;
      }
    },

    total() {
      return this.pricePerToken * this.tokens;
    },
  },

  methods: {
    async purchaseTokens() {
      if (this.purchasing) {
        return;
      }
      this.purchasing = true;

      const result = await this.stripe.createToken(this.card);

      if (result.error) {
        this.purchasing = false;
        this.card_errors = [result.error.message];
        return;
      }

      const responseData = await this.api({
        url: `users/${this.userData.id}/purchase_tokens/`,
        method: "POST",
        json: {
          tokens: this.tokens,
          total: this.total,
          token: result.token.id,
        },
      });

      if (responseData.status === 200) {
        await this.refresh();
        location.reload();
      } else {
        alert(responseData.body);
        location.reload();
      }
    },

    increment() {
      this.tokens += 1;
    },
    decrement() {
      if (this.tokens > 1) {
        this.tokens -= 1;
      }
    },
  },
};
</script>
